module.exports = __webpack_public_path__ + "img/slide_1.5aa5181a.jpg";